export default __webpack_public_path__ + "static/media/drag_actif.4b32825e.svg";